import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { createAction, props } from '@ngrx/store'

import { ScopeVersion } from '@app/core/model/scope-version'
import { ScopePagination } from '../../model/scope-pagination.model'
import { ScopeSection } from '../../model/scope-section'
import { FetchDeliverablePayload } from '../../change-request/model'
import { MoveDeliverablePayload } from '../../model/move-deliverable.payload.model'

export enum ScopePaginatedOverviewActionTypes {
  GET_CURRENT_SCOPE = '[Scope Overview] Get Current Scope',
  GET_CURRENT_SCOPE_SUCCESS = '[Scope Overview] Get Current Scope Success',
  GET_CURRENT_SCOPE_FAIL = '[Scope Overview] Get Current Scope Data Fail',
  GET_CURRENT_SCOPE_VALUES = '[Scope Overview] Get Current Scope Values',
  GET_CURRENT_SCOPE_VALUES_SUCCESS = '[Scope Overview] Get Current Scope Values Success',
  GET_CURRENT_SCOPE_VALUES_FAIL = '[Scope Overview] Get Current Scope Values Fail',
  REQUEST_SCOPE_DELIVERABLES = '[Scope Overview] Request Scope Deliverables',
  GET_SCOPE_DELIVERABLES = '[Scope Overview] Get Scope Deliverables',
  GET_SCOPE_DELIVERABLES_SUCCESS = '[Scope Overview] Get Scope Deliverables Success',
  GET_SCOPE_DELIVERABLES_FAIL = '[Scope Overview] Get Scope Deliverables Fail',
  SHOW_NEXT_BUFFERED_DELIVERABLES = '[Scope Overview] Show Next Buffered Deliverables',
  GET_SCOPE_SECTIONS = '[Scope Overview] Get Scope Sections',
  REQUEST_SCOPE_SECTIONS = '[Scope Overview] Request Scope Sections',
  GET_SCOPE_SECTIONS_SUCCESS = '[Scope Overview] Get Scope Sections Success',
  GET_SCOPE_SECTIONS_FAIL = '[Scope Overview] Get Scope Sections Fail',
  GET_SCOPE_SECTION = '[Scope Overview] Get Scope Section',
  GET_SCOPE_SECTION_SUCCESS = '[Scope Overview] Get Scope Section Success',
  GET_SCOPE_SECTION_FAIL = '[Scope Overview] Get Scope Section Fail',
  MOVE_DELIVERABLE = '[Scope Overview] Move Deliverable',
  MOVE_DELIVERABLE_SUCCESS = '[Scope Overview] Move Deliverable Success',
  MOVE_DELIVERABLE_FAIL = '[Scope Overview] Move Deliverable Fail',
  REQUEST_SCOPE_SECTION_DELIVERABLES = '[Scope Overview] Request Scope Section Deliverables',
  GET_SCOPE_SECTION_DELIVERABLES = '[Scope Overview] Get Scope Section Deliverables',
  GET_SCOPE_SECTION_DELIVERABLES_SUCCESS = '[Scope Overview] Get Scope Section Deliverables Success',
  GET_SCOPE_SECTION_DELIVERABLES_FAIL = '[Scope Overview] Get Scope Section Deliverables Fail',
  GET_SCOPE_DELIVERABLE = '[Scope Overview] Get Scope Deliverable',
  GET_SCOPE_DELIVERABLE_SUCCESS = '[Scope Overview] Get Scope Deliverable Success',
  GET_SCOPE_DELIVERABLE_FAIL = '[Scope Overview] Get Scope Deliverable Fail',
  GET_UPDATED_DELIVERABLE = '[Scope Overview] Get Updated Scope Deliverable',
}

const getScopeDeliverable = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLE,
  props<FetchDeliverablePayload>()
)
const getScopeDeliverableSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLE_SUCCESS,
  props<{ deliverable?: Deliverable; isUpdated?: boolean }>()
)
const getScopeDeliverableFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLE_FAIL,
  props<{ deliverableId: number; error?: string }>()
)

const getUpdatedDeliverable = createAction(
  ScopePaginatedOverviewActionTypes.GET_UPDATED_DELIVERABLE,
  props<{ scopeId?: number; deliverableId: number }>()
)

const getCurrentScope = createAction(ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE, props<{ scopeId?: number }>())
const getCurrentScopeSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE_SUCCESS,
  props<{ currentScope: ScopeVersion }>()
)
const getCurrentScopeFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE_FAIL,
  props<{ error?: string }>()
)

const getCurrentScopeValues = createAction(
  ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE_VALUES,
  props<{ scopeId?: number }>()
)
const getCurrentScopeValuesSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE_VALUES_SUCCESS,
  props<{ currentScope: ScopeVersion }>()
)
const getCurrentScopeValuesFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_CURRENT_SCOPE_VALUES_FAIL,
  props<{ error?: string }>()
)

const requestScopeDeliverables = createAction(
  ScopePaginatedOverviewActionTypes.REQUEST_SCOPE_DELIVERABLES,
  props<{ scopeId: number }>()
)
const getScopeDeliverables = createAction(ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLES)
const getScopeDeliverablesSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLES_SUCCESS,
  props<{ response: ScopePagination<Deliverable> }>()
)
const getScopeDeliverablesFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_DELIVERABLES_FAIL,
  props<{ error?: string }>()
)

const showNextBufferedDeliverables = createAction(ScopePaginatedOverviewActionTypes.SHOW_NEXT_BUFFERED_DELIVERABLES)

const getScopeSections = createAction(ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTIONS)
const requestScopeSections = createAction(
  ScopePaginatedOverviewActionTypes.REQUEST_SCOPE_SECTIONS,
  props<{ scopeId: number }>()
)
const getScopeSectionsSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTIONS_SUCCESS,
  props<{ response: ScopePagination<ScopeSection> }>()
)
const getScopeSectionsFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTIONS_FAIL,
  props<{ error?: string }>()
)

const getScopeSection = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION,
  props<{ sectionId: number }>()
)
const getScopeSectionSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION_SUCCESS,
  props<{ section: ScopeSection }>()
)
const getScopeSectionFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION_FAIL,
  props<{ sectionId: number; error?: string }>()
)

const moveDeliverable = createAction(
  ScopePaginatedOverviewActionTypes.MOVE_DELIVERABLE,
  props<MoveDeliverablePayload>()
)
const moveDeliverableSuccess = createAction(
  ScopePaginatedOverviewActionTypes.MOVE_DELIVERABLE_SUCCESS,
  props<MoveDeliverablePayload>()
)
const moveDeliverableFail = createAction(
  ScopePaginatedOverviewActionTypes.MOVE_DELIVERABLE_FAIL,
  props<MoveDeliverablePayload & { error?: string }>()
)

const requestScopeSectionDeliverables = createAction(
  ScopePaginatedOverviewActionTypes.REQUEST_SCOPE_SECTION_DELIVERABLES,
  props<{ scopeId: number; sectionId: number }>()
)
const getScopeSectionDeliverables = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION_DELIVERABLES,
  props<{ sectionId: number }>()
)
const getScopeSectionDeliverablesSuccess = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION_DELIVERABLES_SUCCESS,
  props<{ sectionId: number; response: ScopePagination<Deliverable> }>()
)
const getScopeSectionDeliverablesFail = createAction(
  ScopePaginatedOverviewActionTypes.GET_SCOPE_SECTION_DELIVERABLES_FAIL,
  props<{ sectionId: number; error?: string }>()
)

export const ScopePaginatedOverviewActions = {
  getScopeDeliverable,
  getScopeDeliverableSuccess,
  getScopeDeliverableFail,
  getUpdatedDeliverable,
  getCurrentScope,
  getCurrentScopeSuccess,
  getCurrentScopeFail,
  getCurrentScopeValues,
  getCurrentScopeValuesSuccess,
  getCurrentScopeValuesFail,
  getScopeDeliverables,
  requestScopeDeliverables,
  getScopeDeliverablesSuccess,
  getScopeDeliverablesFail,
  showNextBufferedDeliverables,
  getScopeSections,
  requestScopeSections,
  getScopeSectionsSuccess,
  getScopeSectionsFail,
  getScopeSection,
  getScopeSectionSuccess,
  getScopeSectionFail,
  moveDeliverable,
  moveDeliverableSuccess,
  moveDeliverableFail,
  requestScopeSectionDeliverables,
  getScopeSectionDeliverables,
  getScopeSectionDeliverablesSuccess,
  getScopeSectionDeliverablesFail,
}
